import { createQueryString, encodeQueryParams } from '@utils';

import { IPaginatedResponse } from '../common';
import { RequestService } from '../request';

import { IGanttResource, IGanttTask, ITask, ITaskFilters } from './task.contract';

export class TaskService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  public findPendingTasks() {
    return this.fetcher<ITask[]>('/tasks/pending');
  }

  public findTasks(filters: ITaskFilters, page: number, limit: number) {
    const query = createQueryString({
      filters,
      page,
      limit
    });
    return this.fetcher<IPaginatedResponse<ITask>>(`/tasks?${query}`);
  }

  public getCourseGanttChartData = async (courseId: string, assigneeId?: string) => {
    const query = encodeQueryParams({
      ...(courseId && { courseId }),
      ...(assigneeId && { assigneeId })
    });
    return this.fetcher<{ tasks: IGanttTask[]; resources: IGanttResource[] }>(
      `/courses/tasks/gantt?${query}`
    );
  };
}
